import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, withStyles, FormControl, TextField } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import PageTitle from '../../components/PageTitle/PageTitle';
import IconButton from '@material-ui/core/IconButton';
import * as Icons from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Loader from '../../components/Loader/LoaderView';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage, setSelectTenant } from '../../utils/common';
import CustomFooter from '../../components/Table/CustomFooter';
import SelectTenant from '../../components/Select/SelectTenant';

class RoutersManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant: 0,
    };
  }

  async componentDidMount() {
    const { offset, limit, search, sort, order, action, tenantIds } = this.props.router.toJS();

    if (action) {
      this.setState({
        tenant: tenantIds && tenantIds.length > 0 ? JSON.stringify(tenantIds) : 0,
      });

      await this.props.router.getRouterList(offset, limit, search, sort, order, tenantIds);
      this.props.router.setAction('action', null);
    } else {
      const tenantIds = localStorage.getItem('select_tenant') ? [+localStorage.getItem('select_tenant')] : null;
      this.setState({
        tenant: tenantIds ? JSON.stringify(tenantIds) : 0,
      });

      this.props.router.resetData();
      this.props.router.setData('tenantIds', tenantIds);
      // await this.props.router.getRouterList();
    }
  }

  deleteItem(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<span class="swal-icon">
              <i
                class="fa fa-trash-o fa-3x fa-border"
                style="border: solid .08em #f27474; border-radius: 1.1em; margin-bottom: 35px; margin-top: 22px;">
              </i>
            </span>
            <br/>
            <h4>${t('delete_router')}`,
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('delete')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.router.deleteRouter(id);
          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('delete_success')}`,
              type: 'success',
            }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                const { offset, limit, search, sort, order, tenantIds } = this.props.router.toJS();
                await this.props.router.getRouterList(offset, limit, search, sort, order, tenantIds);
                // await this.props.router._getRouterList();
              }
            });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        }
      }
    });
  }

  formatDate(date) {
    return (date = moment(date).format('DD MMMM YYYY'));
  }

  createRouter() {
    const { classes, t } = this.props;
    return (
      <Button
        variant='outlined'
        color='primary'
        onClick={() => this.props.history.push('routers/create')}
        className={classes.button}
      >
        <Icons.Add />
        {t('create_router')}
      </Button>
    );
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.router.toJS();
    return (
      <div className={classes.titleBar}>
        <SelectTenant handleChangeTenant={this.handleChangeTenant} tenant={this.state.tenant} />
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.router.setData('offset', 0, false);
    this.props.router.setData('search', value);
  };

  handleChangeTenant = async (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });

    const tenantIds = JSON.parse(value);
    await this.props.router.setData('tenantIds', tenantIds);
    setSelectTenant(tenantIds);
  };

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  handleChangeRowsPerPage = (value) => {
    this.props.router.setData('limit', value);
  };

  handlechangePage = (value) => {
    const { limit } = this.props.router.toJS();
    this.props.router.setData('offset', value * limit);
  };

  render() {
    const { t, classes } = this.props;
    const { routerList, limit, search, sort, order, loading } = this.props.router.toJS();
    const page = routerList.data ? routerList.pagination.page - 1 : 0;
    const count = routerList.data ? routerList.pagination.count : 0;

    const ARRAYSIZE = 10;
    const columns = [
      {
        name: 'id',
        label: `${t('id')}`,
        options: {
          filter: true,
          sort: true,
          display: true,
          sortDirection: sort === 'id' && order ? order : 'none',
        },
      },
      {
        name: 'serial',
        label: `${t('serial')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'serial' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[1]}</div>;
          },
        },
      },
      {
        name: 'name',
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[2]}</div>;
          },
        },
      },
      {
        name: 'type.name',
        label: `${t('type')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'type.name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[3]}</div>;
          },
        },
      },
      {
        name: 'place',
        label: `${t('place')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'place' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[4]}</div>;
          },
        },
      },
      {
        name: 'tenant.name',
        label: `${t('tenant')}`,
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[5]}</div>;
          },
        },
      },
      {
        name: 'map.name',
        label: `${t('map')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'map.name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[6]}</div>;
          },
        },
      },
      {
        name: 'purchasedDate',
        label: `${t('purchased_date')}`,
        options: {
          filter: true,
          sort: true,
          display: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={classes.columnWidth200}>
                {this.validateTableRow(row, ARRAYSIZE) && row[7] ? moment(row[5]).format('DD MMM YYYY') : '-'}
              </div>
            );
          },
        },
      },
      {
        name: 'status',
        label: `${t('status')}`,
        options: {
          filter: true,
          sort: true,
          display: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={classes.columnWidth200}>
                {this.validateTableRow(row, ARRAYSIZE) && row[8] ? moment(row[7]).format('DD MMM YYYY') : '-'}
              </div>
            );
          },
        },
      },
      {
        name: '',
        label: `${t('action')}`,
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={classes.actionBox}>
                <Link to={`/app/routers/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/view`}>
                  <IconButton title={t('view')}>
                    <Icons.FormatListBulleted color='primary' />
                  </IconButton>
                </Link>
                <Link to={`/app/routers/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/edit`} title={t('edit')}>
                  <IconButton>
                    {' '}
                    <Icons.Edit color='primary' />
                  </IconButton>
                </Link>
                <IconButton
                  title={t('delete')}
                  disabled={this.validateTableRow(row, ARRAYSIZE) && row[6] ? true : false}
                  onClick={() => this.deleteItem(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')}
                >
                  <Icons.Delete color={this.validateTableRow(row, ARRAYSIZE) && row[6] ? 'disabled' : 'primary'} />
                </IconButton>
              </div>
            );
          },
        },
      },
    ];

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <PageTitle title={t('all_routers')} button={this.createRouter()}>
          {this.titleContent()}
        </PageTitle>
        <Grid className={classes.mainContain} container spacing={32}>
          <Grid item xs={12}>
            <MUIDataTable
              data={routerList.data}
              columns={columns}
              options={{
                count: routerList.data ? routerList.pagination.count : 0,
                page: routerList.data ? routerList.pagination.page - 1 : 0,
                searchText: search,
                serverSide: true,
                pagination: true,
                onTableChange: (action, tableState) => {
                  // console.log(action, tableState);
                  switch (action) {
                    case 'changePage':
                      this.props.router.setData('offset', tableState.page * tableState.rowsPerPage);
                      // this.props.user.setData('page',tableState.page);
                      break;
                    case 'changeRowsPerPage':
                      this.props.router.setData('limit', tableState.rowsPerPage);
                      break;
                    case 'search':
                      this.props.router.setData('offset', 0, false);
                      this.props.router.setData('search', tableState.searchText);
                      break;
                    case 'sort':
                      const sortList = tableState.announceText.split(' ');
                      this.props.router.setData('offset', 0, false);
                      this.props.router.setData('sort', sortList[4], false);
                      this.props.router.setData('order', sortList[6] === 'descending' ? 'desc' : 'asc');
                      break;
                    default:
                      break;
                  }
                },
                print: false,
                download: false,
                viewColumns: false,
                search: false,
                sortFilterList: true,
                sort: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
                rowsPerPageOptions: [10, 15, 50],
                rowsPerPage: limit,
                customFooter: (
                  // count,
                  // page,
                  rowsPerPage,
                  changeRowsPerPage,
                  changePage,
                  textLabels,
                ) => {
                  return (
                    <CustomFooter
                      count={count}
                      page={page}
                      rowsPerPage={limit}
                      changeRowsPerPage={this.handleChangeRowsPerPage}
                      changePage={this.handlechangePage}
                      textLabels={textLabels}
                      rowsPerPageOptions={[10, 15, 50]}
                    />
                  );
                },
              }}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  actionBox: {
    minWidth: '150px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
  },
  contentSelect: {
    display: 'flex',
    '& fieldset': {
      top: '2px',
    },
    '& svg': {
      top: 'calc(58% - 8px)',
    },
    '& select': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  iconSelect: {
    position: 'absolute',
    backgroundColor: 'transparent !important',
    display: 'flex',
    marginBottom: '10px',
    top: 'calc(58% - 3px)',
    right: 'calc(10% - 18px)',
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
  },
  fontTitle: {
    fontWeight: 'bold',
    fontSize: 16,
    marginTop: theme.spacing.unit,
  },
  // formControl: {
  //   '& .MuiInputLabel-shrink': {
  //     transform: 'translate(14px, 10px) scale(1)',
  //   },
  //   margin: theme.spacing.unit / 2,
  //   width: '100%',
  //   marginLeft: theme.spacing.unit * 2,
  // },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
});

export const page = inject('router', 'routerType')(observer(RoutersManager));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
